import { useMemo } from 'react';

import { PartnerSharesCount } from 'types';

import { CustomAsyncSelectOption } from 'modules/_shared/components/CustomAsyncSelect/types/CustomAsyncSelectOption';

type UseGetPartnerCurrentSharesCount = {
  selectedPartnerOption: CustomAsyncSelectOption | null;
};

export const useGetPartnerCurrentSharesCount = ({
  selectedPartnerOption,
}: UseGetPartnerCurrentSharesCount) => {
  const partnerCurrentSharesCount = useMemo(() => {
    if (!selectedPartnerOption) return 0;

    return (
      (selectedPartnerOption?.sharesCount as PartnerSharesCount)?.actual || 0
    );
  }, [selectedPartnerOption]);

  return {
    data: { partnerCurrentSharesCount },
  };
};
